if (typeof TPS == "undefined" || !TPS) {
    var TPS = {};
}

// Order page

TPS.OSD = {
    init: function () {
        this.Templates.init();
        this.Context.init();
        this.PageLoader.init();
        this.Nav.init();
        this.Form.init();
    },
}

TPS.OSD.Templates = {
    formWrapperSelector: '.tps-osd-step[data-step="1"]',
    previewWrapperSelector: '.tps-osd-step[data-step="2"]',
    submittedWrapperSelector: '.tps-osd-step[data-step="3"]',

    formTemplate: null,
    previewTemplate: null,
    submittedTemplate: null,

    init: function () {
        this.make();
    },

    make: function () {
        this.formTemplate = $(this.formWrapperSelector).html();
        this.previewTemplate = $(this.previewWrapperSelector).html();
        this.submittedTemplate = $(this.submittedWrapperSelector).html();
    },

    restore: function () {
        var self = TPS.OSD.Templates;

        $(self.formWrapperSelector).html(self.formTemplate);
        $(self.previewWrapperSelector).html(self.previewTemplate);
        $(self.submittedWrapperSelector).html(self.submittedTemplate);

        TPS.OSD.Form.Masks.init();
    },
}

TPS.OSD.Context = {
    step: null,
    orderId: null,
    // orderData: null,
    progressBarLabelSelector: '.tps-osd-form-section .progress-wrapper .progress-label',
    progressBarSelector: '.tps-osd-form-section .progress .progress-meter',
    stepContentSelector: '.tps-osd-step[data-step]',
    stepsCounter: 0,

    init: function () {
        this.update();
        this.stepsCounter = $(this.stepContentSelector).length;
    },

    update: function(step, order) {
        var self = TPS.OSD.Context;
        self.step = step || self.step || TPS.Util.getUrlParameter('step') || ($('body#order-download').length == 1 ? 4 : 1);
        self.orderId = order || self.orderId || TPS.Util.getUrlParameter('order') || null;
    },

    setProgressBar: function (step) {
        var self = TPS.OSD.Context;
        $(self.progressBarLabelSelector).text('Step ' + step);
        $(self.progressBarSelector).animate({ width: ((100 / self.stepsCounter) * step) + '%' }, 250, 'linear');
    },

    updateHistory: function (step, order) {
        var currentUrl = document.location.pathname + document.location.search;
        var url = null;

        if (order) {
            if (step) {
                url = document.location.pathname + '?order=' + order + '&step=' + step;
                // It should always have a step, but just in case...
            } else {
                url = document.location.pathname + '?order=' + order;
            }
        } else {
            if (step) {
                url = document.location.pathname + '?step=' + step;
                // It should always have a step, but just in case...
            } else {
                url = document.location.pathname;
            }
        }

        if (url && url != currentUrl) {
            history.replaceState(null, document.title, url); // 'Replace' and not 'push' to allow the user backs directly to the order history when he hits the browser back button
        }
    },
}

TPS.OSD.PageLoader = {
    counter: 0,
    loader: null,
    loaderOverlay: null,

    init: function () {
        this.loader = $('.tps-osd-loader');
        this.loaderOverlay = $('.tps-osd-loader-overlay');
    },

    show: function () {
        this.counter = this.counter + 1;

        if (this.counter == 1) {
            this.loader.stop().fadeIn(300);
            this.loaderOverlay.stop().fadeIn(300);
        }
    },

    hide: function () {
        this.counter = this.counter - 1;

        if (this.counter == 0) {
            this.loader.stop().fadeOut(300);
            this.loaderOverlay.stop().fadeOut(300);
        }
    },
}

TPS.OSD.Nav = {
    stepContentSelector: '.tps-osd-step[data-step]',
    fadeSpeed: 300,
    loading: false,

    init: function () {
        this.selectStep(); // Leave to TPS.OSD.Context decide in wich step the page is in
    },

    selectStep: function (step, order) {
        if (this.loading) {
            return false;
        }

        var context = TPS.OSD.Context;

        if (step != '' && step != context.step) {
            TPS.OSD.Templates.restore();
        }

        context.update(step, order);
        step = context.step;
        order = context.orderId;

        context.updateHistory(step, order);

        if (order) {
            $(TPS.OSD.Form.orderSelector).val(order);
        }

        var content = $(this.stepContentSelector).filter('[data-step="' + step + '"]');
        var contentActive;

        if (!content.hasClass('active')) {
            this.loading = true;

            context.setProgressBar(step);

            contentActive = $(this.stepContentSelector).filter('.active');

            if (contentActive.length > 0) {
                contentActive.fadeOut(this.fadeSpeed, function () {
                    var self = TPS.OSD.Nav;

                    contentActive.removeClass('active');

                    content.fadeIn(self.fadeSpeed, function () {
                        content.addClass('active');
                        self.loading = false;
                    });
                });
            } else {
                content.fadeIn(this.fadeSpeed, function () {
                    content.addClass('active');
                    TPS.OSD.Nav.loading = false;
                });
            }
        } else {
            return false;
        }
    },
}

TPS.OSD.Form = {
    // Global selectors
    formWrapperSelector: '.tps-osd-step[data-step="1"]',
    fieldsSelector: 'input[type="text"], input[type="email"], input[type="hidden"], input[type="file"], select, textarea',
    adHocFieldsSelector: '.osd-ad-hoc-field',
    // Fields selectors (with special events)
    countrySelector: '#country',
    stateSelector: '#state',
    yearSelector: '#vehicleYear',
    modelSelector: '#vehicleModel',
    vehicleSelector: '#vehicleTrim',
    exteriorColorSelector: '#vehicleExteriorColorCode',
    exteriorColorDescSelector: '#vehicleExteriorColorDescription',
    interiorColorSelector: '#vehicleInteriorColorCode',
    interiorColorDescSelector: '#vehicleInteriorColorDescription',
    packageSelector: '[name="packageCode"]',
    packageDescSelector: '[name="packageDescription"]',
    optionSelector: '[name="optionCode"]',
    optionDescSelector: '[name="optionDescription"]',
    accessorySelector: '[name="accessoryCode"]',
    accessoryDescSelector: '[name="accessoryDescription"]',
    additionalInsuranceSelector: '#additionalInsurance',
    additionalInsuranceDescSelector: '#additionalInsuranceDescription',
    offerSelector: '[name="offer"]',
    offerDescSelector: '[name="offerDescription"]',
    offerNumSelector: '[name="offerAdditionalData"]',
    deliveryAndDestinationPriceSelector: '#deliveryAndDestination',
    osdDepositPriceSelector: '#osdDeposit',
    disclaimerSelector: '#disclaimer',
    driverLicenseSelector: '#driverLicenseFile',
    driverLicenseNameSelector: '#driverLicenseName',
    driverLicenseBinarySelector: '#driversLicenseBinary',
    driverLicenseIdSelector: '#driversLicenseId',

    // Fields selectors
    orderSelector: '#order',
    buyerFullNameSelector: '#buyerFullName',
    coBuyerFullNameSelector: '#coBuyerFullName',
    streetAddressSelector: '#streetAddress',
    streetAddress2Selector: '#streetAddress2',
    citySelector: '#city',
    codeSelector: '#code',
    emailSelector: '#email',
    alternateEmailSelector: '#alternateEmail',
    homePhoneNumberSelector: '#homePhoneNumber',
    dateOfBirthSelector:'#dateOfBirth',
    mobilePhoneNumberSelector: '#mobilePhoneNumber',
    lienholderSelector: '#lienholder',
    commentsSelector: '#comments',
    previouslyAllocatedCommonOrderSelector: '#previouslyAllocatedCommonOrder',
    deliveryLocationSelector: '#deliveryLocation_select',
    deliveryLocationSelector_hidden: '#deliveryLocation',
    deliveryLocation_DirectShipSelector: '#deliveryLocation_DirectShip',
    orderDateSelector: '#orderDate',
    requestDeliveryDateSelector: '#requestDeliveryDate',

    // Date fields and helpers
    datepickerSelector: '[name="requestDeliveryDate"]',
    datepickerDateOfBirthSelector: '[name="dateOfBirth"]',
    disabledDatesBase: [],
    disabledDatesHolidays: [],

    init: function () {
        this.datepicker();

        TPS.OSD.Form.Events.init();
        TPS.OSD.Form.Masks.init();
        TPS.OSD.Form.Validate.init();
        TPS.OSD.Form.WS.init();
    },

    datepicker: function () {
        var self = this;
        var dateToday = new Date();
        var deliveryMinDate = new Date();

        if (window.OSDOrderScheduleCutOffDate) {
            var scheduleCutOffDate = new Date(window.OSDOrderScheduleCutOffDate);
            if (scheduleCutOffDate > dateToday) {
                deliveryMinDate = scheduleCutOffDate;
            }
        }

        $(self.datepickerDateOfBirthSelector).datepicker({
            dateFormat: 'mm/dd/yy',
            maxDate: new Date(new Date().setFullYear(dateToday.getFullYear() - 18)),
            changeMonth: true,
            changeYear: true,
            yearRange: (dateToday.getFullYear() - 100).toString() + ":" + (dateToday.getFullYear() - 18).toString(),
            defaultDate: new Date(1927, 0, 1)
        });

        $(self.datepickerSelector).datepicker({
            dateFormat: 'mm/dd/yy',
            minDate: deliveryMinDate,

            beforeShowDay: function (date) {
                if (date && $(this).filter('#requestDeliveryDate').length > 0) {
                    var string = $.datepicker.formatDate('yy-mm-dd', date);
                    var disabledDates = self.disabledDatesBase.concat(self.disabledDatesHolidays);
                    var noWeekend = $.datepicker.noWeekends(date);
                    if (noWeekend[0]) {
                        return [disabledDates.indexOf(string) == -1];
                    } else {
                        return [noWeekend[0]];
                    }
                }

                return [true];
            }
        });
    },

    _helperUpdateDisabledDates: function () {
        var today = new Date(),
            endDate = new Date(),
            dateRange = [];

        endDate.setDate(today.getDate() + 100);

        for (var d = today; d <= new Date(endDate); d.setDate(d.getDate() + 1)) {
            dateRange.push($.datepicker.formatDate('yy-mm-dd', d));
        }

        this.disabledDatesBase = dateRange;
    },

    _helperUpdateDisabledDatesByHolidays: function (dates) {
        var dateRange = [];

        $(dates).each(function (index, date) {
            dateRange.push($.datepicker.formatDate('yy-mm-dd', date.Date));
        });

        this.disabledDatesHolidays = dateRange;
    },

    _helperAddAssociatedField(name, label, placeholder, additionalClasses = '', isRequired = true, type = 'text', attributes) {
        //console.log(name);

        if (!placeholder)
            placeholder = label;

        var attrHtml = ``;
        for (var key in attributes) {
            attrHtml += ` ${key}='${attributes[key]}'`;
        }

        var html = `
            <div class="form-control-wrapper ${isRequired ? ' required' : ''} ${additionalClasses}">
              <label class="EditingFormLabel show-for-sr" for="${name}">${label}</label>
              <div class="EditingFormControlNestedControl editing-form-control-nested-control">
                  <input name="${name}" type="${type}" maxlength="200" class="form-control" placeholder="${placeholder}"${attrHtml}>
              </div>
            </div>
        `;

        return html;
    },

    getFormData: function () {
        var self = TPS.OSD.Form;
        var data = $(self.formWrapperSelector).find(self.fieldsSelector).serializeArray();
        var dataStructured = {};

        $(data).each(function (index, obj) {
            var date;
            if (typeof dataStructured[obj.name] == 'undefined') {
                // Integers
                if (obj.name == 'order' || obj.name == 'country' || obj.name == 'state' || obj.name == 'vehicleExteriorColorCode' || obj.name == 'vehicleInteriorColorCode' || obj.name == 'vehicleModel' || obj.name == 'vehicleTrim' || obj.name == 'vehicleYear' || obj.name == 'driversLicenseId' || obj.name == 'deliveryLocation') {
                    if (isNaN(parseInt(obj.value))) {
                        dataStructured[obj.name] = 0;
                    } else {
                        dataStructured[obj.name] = parseInt(obj.value);
                    }
                    // Array of integers
                } else if (obj.name == 'accessoryCode' || obj.name == 'optionCode' || obj.name == 'packageCode' || obj.name == 'offer' || obj.name == 'additionalInsurance') {
                    if (isNaN(parseInt(obj.value))) {
                        dataStructured[obj.name] = [0];
                    } else {
                        dataStructured[obj.name] = [parseInt(obj.value)];
                    }
                } else if (obj.name == 'offerAdditionalData') {
                    dataStructured[obj.name] = [obj.value];
                // Dates (datepicker)
                } else if (obj.name == 'requestDeliveryDate' || obj.name == 'dateOfBirth') {
                    date = $('#' + obj.name).datepicker('getDate');
                    dataStructured[obj.name] = $.datepicker.formatDate('yy-mm-dd', date);
                // Dates (readonly)
                } else if (obj.name == 'orderDate') {
                    date = $('#' + obj.name).val();
                    dataStructured[obj.name] = date.replace(/([0-9]+)\/([0-9]+)\/([0-9]+)/, '$3-$1-$2');
                // Hidden IDs
                } else if (obj.name == 'deliveryAndDestination' || obj.name == 'osdDeposit') {
                    var id = $('#' + obj.name).data('id');
                    dataStructured[obj.name] = id;
                // Everything else
                } else {
                    dataStructured[obj.name] = obj.value;
                }
            } else {
                // Array of integers (there is already ONE item in the array)
                if (obj.name.indexOf('AdditionalData') > 0) {
                    dataStructured[obj.name].push(obj.value);
                } else if(typeof dataStructured[obj.name] == 'string') {
                    var temp = dataStructured[obj.name];

                    if (isNaN(parseInt(obj.value))) {
                        dataStructured[obj.name] = [temp, 0];
                    } else {
                        dataStructured[obj.name] = [temp, parseInt(obj.value)];
                    }
                // Array of integers (there is MORE THAN ONE item in the array)
                } else {

                    if (isNaN(parseInt(obj.value))) {
                        dataStructured[obj.name].push(0);
                    } else {
                        dataStructured[obj.name].push(parseInt(obj.value));
                    }
                }
            }
        });

        var parsedData = self.getParsedData(dataStructured);

        return parsedData;
    },

    getParsedData: function (data) {
        var self = TPS.OSD.Form;

        var customerModel = {
            // CustomerID: 0, // Back-end will find this ID based on the order
            BuyerFullName: data.buyerFullName,
            CoBuyerFullName: data.coBuyerFullName,
            Address: data.streetAddress,
            Address2: data.streetAddress2,
            CountryID: data.country,
            StateID: data.state,
            CityName: data.city,
            ZipCode: data.code,
            Email: data.email,
            AlternativeEmail: data.alternateEmail,
            HomePhone: data.homePhoneNumber,
            DateOfBirth: data.dateOfBirth,
            MobilePhone: data.mobilePhoneNumber,
            Comments: data.comments,
            DriverLicenseFileName: data.driverLicenseName,
            DriverLicenseBinary: data.driversLicenseBinary,
            DriverLicenseID: data.driversLicenseId,
        };

        var orderModel = {
            // OrderID: 0, // Populated after with a condition
            Customer: customerModel,
            VistaOrder: data.previouslyAllocatedCommonOrder,
            YearID: data.vehicleYear,
            ModelID: data.vehicleModel,
            VehicleID: data.vehicleTrim,
            ExteriorColorID: data.vehicleExteriorColorCode,
            InteriorColorID: data.vehicleInteriorColorCode,
            Accessories: self.parseOptionsArray(data.accessoryCode, data.accessoryCodeAdditionalData),
            Packages: self.parseOptionsArray(data.packageCode, data.packageCodeAdditionalData),
            Options: self.parseOptionsArray(data.optionCode, data.optionCodeAdditionalData),
            OSDDepositID: data.osdDeposit,
            AdditionalInsurance: self.parseOptionsArray(data.additionalInsurance, data.additionalInsuranceAdditionalData),
            Discounts: self.parseOptionsArray(data.offer, data.offerAdditionalData),
            DeliveryPriceID: data.deliveryAndDestination,
            DeliveryLocationID: data.deliveryLocation,
            OrderDate: data.orderDate,
            OrderDeliveryDate: data.requestDeliveryDate,
            Lienholder: data.lienholder,
            Total: parseFloat($(TPS.OSD.Form.Calculator.balanceDueSelector).data('price')) || 0.00,
        };

        // If it's a EDIT order and not a NEW order
        if (data.order != 0) {
            orderModel.OrderID = data.order;
        }

        // TPS.OSD.Context.orderData = orderModel;

        return orderModel;
    },
    /*
     * Parse associated selections for :
     * 
     * 'accessoryCode'
     * 'optionCode'
     * 'packageCode'
     * 'offer'
     * 'additionalInsurance'
     * */
    parseOptionsArray: function (pD, assD = []) {
        var objArr = [];

        $(pD).each(function (k, v) {
            objArr.push({
                'orderComponentID': v,
                'orderAdditionalData': assD[k] ? assD[k] : ''
            });
        });
        return objArr;
    }
}

TPS.OSD.Form.WS = {
    urlDownloadPdf: '/osd/handlers/orderpdf.ashx?orderID={order}',

    init: function () {
        this.loadWebServices();
        this.loadWebServicesData();
    },

    loadWebServices: function () {
        TPS.Util.loadWebserviceJS('CMSApp.OSD.API.Info');
        TPS.Util.loadWebserviceJS('CMSApp.OSD.API.Order');
    },

    loadWebServicesData: function () {
        var step = TPS.OSD.Context.step;
        var order = TPS.OSD.Context.orderId;

        if (order != null) {
            // Edit order
            if (step == 1) {
                this.loadOrder_editMode(order);
            // Preview/review order
            } else {
                this.loadOrder_previewMode(order, step);
            }
        // New order
        } else {
            this.loadCountries();
            this.loadYears();
            this.loadAdditionalInsurances();
            this.loadOffers();
            this.loadDeposits();
            this.loadDeliveryLocations();
            this.loadDeliveryPrices();
            this.loadOrderDate();
        }
    },

    loadOrder_editMode: function (order) {
        TPS.OSD.PageLoader.show();

        TPS.OSD.Form.datepicker();

        CMSApp.OSD.API.Order.LoadOrder(order, function (data) {
            if (data.Success && data.Success == true && data.ObjectVM) {
                var order = data.ObjectVM;
                TPS.OSD.Form.WS.setOrder_editMode(order);
            } else if (data.Messages && data.Messages.length > 0) {
                alert(data.Messages[0]);
            } else {
                alert('Error loading order. Please refresh the page and try again.');
            }

            TPS.OSD.PageLoader.hide();
        }, function () {
            alert('Error loading order. Please refresh the page and try again.');
            TPS.OSD.PageLoader.hide();
        });
    },

    loadOrder_previewMode: function (order, step) {
        TPS.OSD.PageLoader.show();

        CMSApp.OSD.API.Order.LoadOrderPreview(order, function (data) {
            if (data.Success && data.Success == true && data.ObjectVM) {
                var order = data.ObjectVM;
                TPS.OSD.Form.WS.setOrder_previewMode(order, step);
            } else if (data.Messages && data.Messages.length > 0) {
                alert(data.Messages[0]);
            } else {
                alert('Error loading order. Please refresh the page and try again.');
            }

            TPS.OSD.PageLoader.hide();
        }, function () {
            alert('Error loading order. Please refresh the page and try again.');
            TPS.OSD.PageLoader.hide();
        });
    },

    _helperLoadData: function (getFunction, functionParam, functionParam2, callbackSuccess, callbackError) {
        TPS.OSD.PageLoader.show();

        if (functionParam != null && functionParam2 != null) {
            getFunction(functionParam, functionParam2, function (data) {
                callbackSuccess.call(this, data);
                TPS.OSD.PageLoader.hide();
            }, function () {
                callbackError.call(this);
                TPS.OSD.PageLoader.hide();
            });
        }
        else if (functionParam != null) {
            getFunction(functionParam, function (data) {
                callbackSuccess.call(this, data);
                TPS.OSD.PageLoader.hide();
            }, function () {
                callbackError.call(this);
                TPS.OSD.PageLoader.hide();
            });
        } else {
            getFunction(function (data) {
                callbackSuccess.call(this, data);
                TPS.OSD.PageLoader.hide();
            }, function () {
                callbackError.call(this);
                TPS.OSD.PageLoader.hide();
            });
        }
    },

    loadCountries: function () {
        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetCountries,
            null,
            null,

            function (data) {
                TPS.OSD.Form.WS.setCountries(data);
                $(TPS.OSD.Form.countrySelector).find('option').filter(function () { return $(this).text() == 'USA' }).prop('selected', true);
                TPS.OSD.Form.WS.loadStates($(TPS.OSD.Form.countrySelector).val());
                TPS.OSD.Form.Masks.setZipCodeMask();
            },

            function () {
                alert('Error getting the countries data. Please refresh the page and try again.');
            }
        );
    },

    loadStates: function (country) {
        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetStates,
            country,
            null,
            TPS.OSD.Form.WS.setStates,

            function () {
                alert('Error getting the states data. Please refresh the page and try again.');
            }
        );
    },

    loadYears: function () {
        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetYears,
            null,
            null,
            TPS.OSD.Form.WS.setYears,

            function () {
                alert('Error getting the vehicle years data. Please refresh the page and try again.');
            }
        );
    },

    loadModels: function (year) {
        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetModels,
            year,
            null,
            TPS.OSD.Form.WS.setModels,

            function () {
                alert('Error getting the vehicle models data. Please refresh the page and try again.');
            }
        );
    },

    loadVehicles: function (model) {
        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetVehicles,
            model,
            null,
            TPS.OSD.Form.WS.setVehicles,

            function () {
                alert('Error getting the vehicles data. Please refresh the page and try again.');
            }
        );
    },

    loadExtColors: function (vehicle) {
        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetExteriorColors,
            vehicle,
            null,
            TPS.OSD.Form.WS.setExteriorColors,

            function () {
                alert('Error getting the vehicle exterior colors data. Please refresh the page and try again.');
            }
        );
    },

    loadIntColors: function (vehicle, exteriorColor) {
        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetInteriorColors,
            vehicle,
            exteriorColor,
            TPS.OSD.Form.WS.setInteriorColors,

            function () {
                alert('Error getting the vehicle interior colors data. Please refresh the page and try again.');
            }
        );
    },

    loadPackages: function (vehicle) {
        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetPackages,
            vehicle,
            null,
            TPS.OSD.Form.WS.setPackages,

            function () {
                alert('Error getting the vehicle packages data. Please refresh the page and try again.');
            }
        );
    },

    loadOptions: function (vehicle) {
        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetOptions,
            vehicle,
            null,
            TPS.OSD.Form.WS.setOptions,

            function () {
                alert('Error getting the vehicle options data. Please refresh the page and try again.');
            }
        );
    },

    loadAccessories: function (vehicle) {
        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetAccessories,
            vehicle,
            null,
            TPS.OSD.Form.WS.setAccessories,

            function () {
                alert('Error getting the vehicle accessories data. Please refresh the page and try again.');
            }
        );
    },

    loadAdditionalInsurances: function () {
        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetAdditionalInsurances,
            null,
            null,
            TPS.OSD.Form.WS.setAdditionalInsurances,

            function () {
                alert('Error getting the insurance data. Please refresh the page and try again.');
            }
        );
    },

    loadOffers: function () {
        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetDiscounts,
            null,
            null,
            TPS.OSD.Form.WS.setOffers,

            function () {
                alert('Error getting the offers data. Please refresh the page and try again.');
            }
        );
    },

    loadDeposits: function () {
        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetDeposits,
            null,
            null,

            function (data) {
                TPS.OSD.Form.WS.setDeposits(data);
                $(TPS.OSD.Form.osdDepositPriceSelector).trigger('change');
            },

            function () {
                alert('Error getting the deposits data. Please refresh the page and try again.');
            }
        );
    },

    loadDeliveryPrices: function () {
        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetDeliveryPrices,
            null,
            null,

            function (data) {
                TPS.OSD.Form.WS.setDeliveryPrices(data);
                $(TPS.OSD.Form.deliveryAndDestinationPriceSelector).trigger('change');
            },

            function () {
                alert('Error getting the delivery prices data. Please refresh the page and try again.');
            }
        );
    },

    loadDeliveryLocations: function () {
        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetDeliveryLocations,
            null,
            null,

            function (data) {
                TPS.OSD.Form.WS.setDeliveryLocations(data);

                $(TPS.OSD.Form.deliveryLocationSelector).trigger('change');
            },

            function () {
                alert('Error getting the delivery locations data. Please refresh the page and try again.');
            }
        );
    },

    loadHolidays: function (_locationId) {

        if (_locationId) {
            TPS.OSD.Form.WS._helperLoadData(
                CMSApp.OSD.API.Info.GetHolidays,
                _locationId,
                null,

                function (data) {
                    TPS.OSD.Form._helperUpdateDisabledDatesByHolidays(data);
                    $(TPS.OSD.Form.requestDeliveryDateSelector).prop('disabled', false);
                },

                function () {
                    alert('Error getting the Swedish holidays data. Please refresh the page and try again.');
                }
            );
        }
    },

    loadOrderDate: function () {
        var today = $.datepicker.formatDate('yy-mm-dd', new Date());
        $(TPS.OSD.Form.orderDateSelector).val(today);
        TPS.OSD.Form._helperUpdateDisabledDates();
    },

    _helperSetData: function (data, target, baseHtml, dataType) {
        target.html(baseHtml);

        if (data && data.length > 0) {
            $.each(data, function (index, value) {
                if (dataType == 1) {
                    target.append('<option value="' + value.ID + '">' + value.Name + '</option>');
                } else if (dataType == 2) {
                    target.append('<option value="' + value.ID + '" data-price="' + value.Price + '">' + value.Description + '</option>');
                } else if (dataType == 3) {
                    target.append('<option value="' + value.ID + '" data-code="' + value.Code + '" data-price="' + value.Price + '" data-description="' + encodeURIComponent(value.Description) + '">' + value.Name + ' (' + value.Code + ')</option>');
                } else if (dataType == 4) {
                    target.append('<option value="' + value.ID + '" data-price="' + value.Price + '">' + TPS.Util.formatPrice(value.Price) + '</option>');
                } else if (dataType == 5) {
                    target.append('<option value="' + value.ID + '" data-price="' + value.Price + '">' + TPS.Util.formatPrice(-value.Price) + '</option>');
                } else if (dataType == 6) {
                    target.append('<option value="' + value.ID + '">' + value.Description + '</option>');
                } else if (dataType == 7) {
                    target.append('<option value="' + value.ID + '" data-price="' + value.Price + '" data-description="' + encodeURIComponent(value.Description) + '">' + value.Name + '</option>');
                }
            });
        }
    },
    
    setCountries: function (data) {
        TPS.OSD.Form.WS._helperSetData(
            data,
            $(TPS.OSD.Form.countrySelector),
            '<option selected="selected" value="">Country</option>',
            1
        );
    },

    setStates: function (data) {
        TPS.OSD.Form.WS._helperSetData(
            data,
            $(TPS.OSD.Form.stateSelector),
            '<option selected="selected" value="">State</option>',
            1
        );
    },

    setYears: function (data) {
        TPS.OSD.Form.WS._helperSetData(
            data,
            $(TPS.OSD.Form.yearSelector),
            '<option selected="selected" value="">Year</option>',
            1
        );
    },

    setModels: function (data) {
        TPS.OSD.Form.WS._helperSetData(
            data,
            $(TPS.OSD.Form.modelSelector),
            '<option selected="selected" value="">Model</option>',
            1
        );
    },

    setVehicles: function (data) {
        TPS.OSD.Form.WS._helperSetData(
            data,
            $(TPS.OSD.Form.vehicleSelector),
            '<option selected="selected" value="">Trim</option>',
            2
        );
    },

    setExteriorColors: function (data) {
        TPS.OSD.Form.WS._helperSetData(
            data,
            $(TPS.OSD.Form.exteriorColorSelector),
            '<option selected="selected" value="">Exterior Color</option>',
            3
        );
    },

    setInteriorColors: function (data) {
        TPS.OSD.Form.WS._helperSetData(
            data,
            $(TPS.OSD.Form.interiorColorSelector),
            '<option selected="selected" value="">Interior Color</option>',
            3
        );
    },

    setPackages: function (data) {
        TPS.OSD.Form.WS._helperSetData(
            data,
            $(TPS.OSD.Form.packageSelector),
            '<option selected="selected" value="">Package</option>',
            3
        );
    },

    setOptions: function (data) {
        TPS.OSD.Form.WS._helperSetData(
            data,
            $(TPS.OSD.Form.optionSelector),
            '<option selected="selected" value="">Option</option>',
            3
        );
    },

    setAccessories: function (data) {
        TPS.OSD.Form.WS._helperSetData(
            data,
            $(TPS.OSD.Form.accessorySelector),
            '<option selected="selected" value="">Accessory</option>',
            3
        );
    },

    setAdditionalInsurances: function (data) {
        TPS.OSD.Form.WS._helperSetData(
            data,
            $(TPS.OSD.Form.additionalInsuranceSelector),
            '<option selected="selected" value="">Insurance</option>',
            7
        );
    },

    setOffers: function (data) {
        TPS.OSD.Form.WS._helperSetData(
            data,
            $(TPS.OSD.Form.offerSelector),
            '<option selected="selected" value="">Offer</option>',
            7
        );
    },

    setDeliveryLocations: function (data, _value) {


        var deliveryLocationInput = $(TPS.OSD.Form.deliveryLocationSelector);
        var deliveryLocationInput_hidden = $(TPS.OSD.Form.deliveryLocationSelector_hidden);
        var deliveryLocation_DirectShipInput = $(TPS.OSD.Form.deliveryLocation_DirectShipSelector);

        // TODO: Remove this code once BE server is updated
        // to return this option

        TPS.OSD.Form.WS._helperSetData(
            data,
            deliveryLocationInput,
            '<option selected="selected" value="">Drop-off location</option>',
            1
        );

        var selectedValue;

        if (typeof _value !== 'undefined')
        {

            selectedValue = data.filter(function (_item, _i, _arr) {
                return _item.ID === _value;
            });


        }
        else
        {
            selectedValue = data.filter(function (_item, _i, _arr) {
                return _item.Name === 'Gothenburg, Sweden'
            });
        }

        deliveryLocationInput.data('id', selectedValue[0].ID).data('name', selectedValue[0].Name).val(selectedValue[0].ID);

        deliveryLocationInput_hidden.val(selectedValue[0].ID);

        if (selectedValue[0].ID === 0) {
            deliveryLocationInput.prop('disabled', true);
            deliveryLocation_DirectShipInput.prop('checked', true);
        } else {
            deliveryLocationInput.prop('disabled', false);
            deliveryLocation_DirectShipInput.prop('checked', false);
        }

    },

    setDeposits: function (data) {
        var value = data[0];
        $(TPS.OSD.Form.osdDepositPriceSelector).data('id', value.ID).data('price', value.Price).val(TPS.Util.formatPrice(-value.Price));
    },

    setDeliveryPrices: function (data) {
        var value = data[0];
        $(TPS.OSD.Form.deliveryAndDestinationPriceSelector).data('id', value.ID).data('price', value.Price).val(TPS.Util.formatPrice(value.Price));
    },

    setOrder_editMode: function (data) {
        var formObj = TPS.OSD.Form;

        // Customer

        $(formObj.buyerFullNameSelector).val(data.Customer.BuyerFullName);
        $(formObj.coBuyerFullNameSelector).val(data.Customer.CoBuyerFullName);
        $(formObj.streetAddressSelector).val(data.Customer.Address);
        $(formObj.streetAddress2Selector).val(data.Customer.Address2);
        $(formObj.citySelector).val(data.Customer.CityName);
        $(formObj.codeSelector).val(data.Customer.ZipCode);
        $(formObj.emailSelector).val(data.Customer.Email);
        $(formObj.alternateEmailSelector).val(data.Customer.AlternativeEmail);

        $(formObj.homePhoneNumberSelector).val(data.Customer.HomePhone);        
        $(formObj.mobilePhoneNumberSelector).val(data.Customer.MobilePhone);
        $(formObj.dateOfBirthSelector).val(data.Customer.DateOfBirth);
        TPS.OSD.Form.Masks.setPhoneMask();

        $(formObj.commentsSelector).val(data.Customer.Comments);
        $(formObj.previouslyAllocatedCommonOrderSelector).val(data.VistaOrder);
        $(formObj.lienholderSelector).val(data.Lienholder);
        $(formObj.driverLicenseNameSelector).val(data.Customer.DriverLicenseFileName);
        $(formObj.driverLicenseIdSelector).val(data.Customer.DriverLicenseID);

        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetCountries,
            null,
            null,

            function (data2) {
                TPS.OSD.Form.WS.setCountries(data2);
                $(formObj.countrySelector).find('option[value="' + data.Customer.CountryID + '"]').prop('selected', true);
                TPS.OSD.Form.Masks.setZipCodeMask();
            },

            function () {
                alert('Error getting the countries data. Please refresh the page and try again.');
            }
        );

        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetStates,
            data.Customer.CountryID,
            null,

            function (data2) {
                TPS.OSD.Form.WS.setStates(data2);
                $(formObj.stateSelector).find('option[value="' + data.Customer.StateID + '"]').prop('selected', true);
            },

            function () {
                alert('Error getting the states data. Please refresh the page and try again.');
            }
        );

        TPS.OSD.Form._helperUpdateDisabledDates();

        // Order

        $(formObj.orderSelector).val(data.OrderID);
        $(formObj.orderDateSelector).val(data.OrderDate);

        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetYears,
            null,
            null,

            function (data2) {
                TPS.OSD.Form.WS.setYears(data2);
                $(formObj.yearSelector).find('option[value="' + data.YearID + '"]').prop('selected', true);
            },

            function () {
                alert('Error getting the vehicle years data. Please refresh the page and try again.');
            }
        );

        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetModels,
            data.YearID,
            null,

            function (data2) {
                TPS.OSD.Form.WS.setModels(data2);
                $(formObj.modelSelector).find('option[value="' + data.ModelID + '"]').prop('selected', true);
            },

            function () {
                alert('Error getting the vehicle models data. Please refresh the page and try again.');
            }
        );

        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetVehicles,
            data.ModelID,
            null,

            function (data2) {
                TPS.OSD.Form.WS.setVehicles(data2);
                $(formObj.vehicleSelector).find('option[value="' + data.VehicleID + '"]').prop('selected', true);
                $(formObj.vehicleSelector).trigger('change_load_edit_order');
            },

            function () {
                alert('Error getting the vehicles data. Please refresh the page and try again.');
            }
        );

        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetExteriorColors,
            data.VehicleID,
            null,

            function (data2) {
                TPS.OSD.Form.WS.setExteriorColors(data2);
                $(formObj.exteriorColorSelector).find('option[value="' + data.ExteriorColorID + '"]').prop('selected', true);
                $(formObj.exteriorColorSelector).trigger('change', [true]);
            },

            function () {
                alert('Error getting the vehicle exterior colors data. Please refresh the page and try again.');
            }
        );

        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetInteriorColors,
            data.VehicleID,
            data.ExteriorColorID,

            function (data2) {
                TPS.OSD.Form.WS.setInteriorColors(data2);
                $(formObj.interiorColorSelector).find('option[value="' + data.InteriorColorID + '"]').prop('selected', true);
                $(formObj.interiorColorSelector).trigger('change');
            },

            function () {
                alert('Error getting the vehicle interior colors data. Please refresh the page and try again.');
            }
        );

        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetPackages,
            data.VehicleID,
            null,

            function (data2) {
                
                TPS.OSD.Form.WS.setPackages(data2);

                $.each(data.Packages, function (index, value) {
                    if (index > 0) {
                        $($(formObj.packageSelector).get(index - 1)).closest('.row').find(TPS.OSD.Form.Events.addNewItemButtonSelector).trigger('click');
                    }
                    var codeEl = $($(formObj.packageSelector).get(index));
                    codeEl.find('option[value="' + value.orderComponentID + '"]').prop('selected', true);
                    codeEl.trigger('change');
                });
            },

            function () {
                alert('Error getting the vehicle packages data. Please refresh the page and try again.');
            }
        );

        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetOptions,
            data.VehicleID,
            null,

            function (data2) {
                TPS.OSD.Form.WS.setOptions(data2);

                $.each(data.Options, function (index, value) {
                    if (index > 0) {
                        $($(formObj.optionSelector).get(index - 1)).closest('.row').find(TPS.OSD.Form.Events.addNewItemButtonSelector).trigger('click');
                    }

                    var codeEl = $($(formObj.optionSelector).get(index));
                    codeEl.find('option[value="' + value.orderComponentID + '"]').prop('selected', true);
                    codeEl.trigger('change');
                });
            },

            function () {
                alert('Error getting the vehicle options data. Please refresh the page and try again.');
            }
        );

        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetAccessories,
            data.VehicleID,
            null,

            function (data2) {
                TPS.OSD.Form.WS.setAccessories(data2);

                $.each(data.Accessories, function (index, value) {
                    if (index > 0) {
                        $($(formObj.accessorySelector).get(index - 1)).closest('.row').find(TPS.OSD.Form.Events.addNewItemButtonSelector).trigger('click');
                    }

                    var codeEl = $($(formObj.accessorySelector).get(index));
                    codeEl.find('option[value="' + value.orderComponentID + '"]').prop('selected', true);
                    codeEl.trigger('change');
                });
            },

            function () {
                alert('Error getting the vehicle accessories data. Please refresh the page and try again.');
            }
        );

        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetAdditionalInsurances,
            null,
            null,

            function (data2) {
                TPS.OSD.Form.WS.setAdditionalInsurances(data2);
                $(formObj.additionalInsuranceSelector).find('option[value="' + data.AdditionalInsurance[0].orderComponentID + '"]').prop('selected', true);

                $(formObj.additionalInsuranceSelector).trigger('change');
            },

            function () {
                alert('Error getting the insurance data. Please refresh the page and try again.');
            }
        );

        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetDiscounts,
            null,
            null,

            function (data2) {
                TPS.OSD.Form.WS.setOffers(data2);

                $.each(data.Discounts, function (index, value) {
                    if (index > 0) {
                        $($(formObj.offerSelector).get(index - 1)).closest('.row').find(TPS.OSD.Form.Events.addNewItemButtonSelector).trigger('click');
                    }
                    var codeEl = $($(formObj.offerSelector).get(index));
                    codeEl.find('option[value="' + value.orderComponentID + '"]').prop('selected', true);
                    codeEl.trigger('change');

                    if (value.orderAdditionalData) {
                        var dataEl = $($(formObj.offerNumSelector).get(index));
                        dataEl.val(value.orderAdditionalData).trigger('blur');
                    }

                });
            },

            function () {
                alert('Error getting the offers data. Please refresh the page and try again.');
            }
        );

        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetDeliveryLocations,
            null,
            null,

            function (data2) {
                TPS.OSD.Form.WS.setDeliveryLocations(data2, data.DeliveryLocationID);
                $(formObj.deliveryLocationSelector).trigger('change');

                if (data.OrderDeliveryDate != '1/1/0001') {
                    $(formObj.requestDeliveryDateSelector).val(data.OrderDeliveryDate);
                    $(formObj.requestDeliveryDateSelector).prop('disabled', false);
                }
            },

            function () {
                alert('Error getting the delivery prices data. Please refresh the page and try again.');
            }
        );

        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetDeliveryPrices,
            null,
            null,

            function (data2) {
                TPS.OSD.Form.WS.setDeliveryPrices(data2);
                $(formObj.deliveryAndDestinationPriceSelector).trigger('change');
            },

            function () {
                alert('Error getting the delivery prices data. Please refresh the page and try again.');
            }
        );

        TPS.OSD.Form.WS._helperLoadData(
            CMSApp.OSD.API.Info.GetDeposits,
            null,
            null,

            function (data2) {
                TPS.OSD.Form.WS.setDeposits(data2);
                $(formObj.osdDepositPriceSelector).trigger('change');
            },

            function () {
                alert('Error getting the deposits data. Please refresh the page and try again.');
            }
        );
    },

    setOrder_previewMode: function (data, step) {
        var step = $('.tps-osd-step[data-step="' + step + '"]');

        // Customer

        step.find('.buyerFullName').html(data.Customer.BuyerFullName || '-');
        step.find('.coBuyerFullName').html(data.Customer.CoBuyerFullName || '-');
        step.find('.streetAddress').html(data.Customer.Address || '-');
        step.find('.streetAddress2').html(data.Customer.Address2 || '-');
        step.find('.city').html(data.Customer.CityName || '-');
        step.find('.country').html(data.Customer.CountryName || '-');
        step.find('.state').html(data.Customer.StateName || '-');
        step.find('.code').html(data.Customer.ZipCode || '-');
        step.find('.email').html(data.Customer.Email || '-');
        step.find('.alternateEmail').html(data.Customer.AlternativeEmail || '-');
        step.find('.homePhoneNumber').html(data.Customer.HomePhone || '-');
        step.find('.mobilePhoneNumber').html(data.Customer.MobilePhone || '-');
        step.find('.dateOfBirth').html(data.Customer.DateOfBirth || '-');
        step.find('.comments').html(data.Customer.Comments || '-');
        step.find('.previouslyAllocatedCommonOrder').html(data.VistaOrder || '-');

        // Order

        step.find('.vehicleYear').html(data.YearName || '-');
        step.find('.vehicleModel').html(data.ModelName || '-');
        step.find('.vehicleTrim').html(data.VehicleName || '-');
        step.find('.vehicleBasePrice').html(data.VehiclePrice ? TPS.Util.formatPrice(data.VehiclePrice) : '-');
        step.find('.vehicleExteriorColorCode').html(data.ExteriorColorCode || '-');
        step.find('.vehicleExteriorColorDescription').html(data.ExteriorColorName || '-');
        step.find('.vehicleExteriorColorPrice').html(data.ExteriorColorPrice ? TPS.Util.formatPrice(data.ExteriorColorPrice) : '-');
        step.find('.vehicleInteriorColorCode').html(data.InteriorColorCode || '-');
        step.find('.vehicleInteriorColorDescription').html(data.InteriorColorName || '-');
        step.find('.vehicleSubTotalPrice').html(data.VehiclePrice ? TPS.Util.formatPrice(data.VehiclePrice + (data.ExteriorColorPrice || 0)) : '-');

        // Packages & Options

        var packageAndOptionPriceCounter = -1; // 0 == -1
        var packageAndOptionPrice = 0;

        step.find('.package:not(:first-child)').remove();
        
        $.each(data.Packages, function (index, value) {
            packageAndOptionPriceCounter++;

            if (packageAndOptionPriceCounter > 0) {
                var toClone = $(step.find('.package').get(packageAndOptionPriceCounter - 1));
                var clone = toClone.clone();
                clone.insertAfter(toClone);
            }

            var codeEl = $(step.find('.package').get(packageAndOptionPriceCounter));
            codeEl.find('.packageCode').html(value.Code || '-');
            codeEl.find('.packageDescription').html(value.Description || '-');
            codeEl.find('.packagePrice').html(value.Price ? TPS.Util.formatPrice(value.Price) : '-');

            packageAndOptionPrice += value.Price;
        });

        $.each(data.Options, function (index, value) {
            packageAndOptionPriceCounter++;

            if (packageAndOptionPriceCounter > 0) {
                var toClone = $(step.find('.package').get(packageAndOptionPriceCounter - 1));
                var clone = toClone.clone();
                clone.insertAfter(toClone);
            }

            var codeEl = $(step.find('.package').get(packageAndOptionPriceCounter));
            codeEl.find('.packageCode').html(value.Code || '-');
            codeEl.find('.packageDescription').html(value.Description || '-');
            codeEl.find('.packagePrice').html(value.Price ? TPS.Util.formatPrice(value.Price) : '-');

            packageAndOptionPrice += value.Price;
        });

        step.find('.packageSubTotalPrice').html(packageAndOptionPrice ? TPS.Util.formatPrice(packageAndOptionPrice) : '-');

        // Acessories

        var accessoryPrice = 0;

        step.find('.accessory:not(:first-child)').remove();

        $.each(data.Accessories, function (index, value) {
            if (index > 0) {
                var toClone = $(step.find('.accessory').get(index - 1));
                var clone = toClone.clone();
                clone.insertAfter(toClone);
            }

            var codeEl = $(step.find('.accessory').get(index));
            codeEl.find('.accessoryCode').html(value.Code || '-');
            codeEl.find('.accessoryDescription').html(value.Description || '-');
            codeEl.find('.accessoryPrice').html(value.Price ? TPS.Util.formatPrice(value.Price) : '-');

            accessoryPrice += value.Price;
        });

        step.find('.accessorySubTotalPrice').html(accessoryPrice ? TPS.Util.formatPrice(accessoryPrice) : '-');

        // Retailer

        step.find('.retailerCode').html(data.RetailerCode || '-');
        step.find('.retailerName').html(data.RetailerName || '-');
        step.find('.retailerRepresentativeName').html(data.RetailerRepresentativeName || '-');

        // Offer

        var offerPrice = 0;

        step.find('.offer:not(:first-child):not(:nth-child(2))').remove();

        $.each(data.Discounts, function (index, value) {
            if (index > 0) {
                var toClone = $(step.find('.offer').get(index - 1));
                var clone = toClone.clone();
                clone.insertAfter(toClone);
            }

            var codeEl = $(step.find('.offer').get(index));
            var additionalDataPrefix = value.ID == 1 ? 'PIN#&nbsp;' : value.ID == 2 ? 'VIN#&nbsp;' : ''
            var offerDescription = value.Name ? value.Name : '-';
            offerDescription += value.AdditionalData ? '&nbsp;&nbsp;<strong>(' + additionalDataPrefix + value.AdditionalData + ')</strong>' : '';
            codeEl.find('.offerDescription').html(offerDescription);
            codeEl.find('.offerPrice').html(value.Price ? TPS.Util.formatPrice(-value.Price) : '-');

            offerPrice += value.Price;
        });

        // Additional Insurance and Offer

        var additionalInsuranceAndOfferPrice = 0;

        if (data.AdditionalInsurance.length > 0) {
            
            step.find('.additionalInsurancePrice').html(data.AdditionalInsurance[0].Price ? TPS.Util.formatPrice(data.AdditionalInsurance[0].Price) : '-');
            step.find('.additionalInsuranceDescription').html(data.AdditionalInsurance && data.AdditionalInsurance[0].Description || '-');

            additionalInsuranceAndOfferPrice = data.AdditionalInsurance[0].Price - offerPrice;            
        }
        else {
            step.find('.additionalInsurancePrice').html('-');
            step.find('.additionalInsuranceDescription').html('-');

            additionalInsuranceAndOfferPrice = - offerPrice;         
        }

        step.find('.additionalInsuranceAndOfferPrice').html(additionalInsuranceAndOfferPrice ? TPS.Util.formatPrice(additionalInsuranceAndOfferPrice) : '-');

        // Price

        step.find('.deliveryAndDestinationPrice').html(data.DeliveryPrice ? TPS.Util.formatPrice(data.DeliveryPrice) : '-');
        step.find('.grandTotalPrice').html(data.Total ? TPS.Util.formatPrice(data.Total + (data.OSDDeposit || 0)) : '-');
        step.find('.osdDeposit').html(data.OSDDeposit ? TPS.Util.formatPrice(-data.OSDDeposit) : '-');
        step.find('.balanceDue').html(data.Total ? TPS.Util.formatPrice(data.Total) : '-');

        //Delivery location
        step.find('.deliveryLocation').html(data.DeliveryLocation);

        //Lienholder
        step.find('.lienholder').html(data.Lienholder || '-');

        // Date
        
        step.find('.orderDate').html(data.OrderDate || '-');
        step.find('.requestDeliveryDate').html(data.OrderDeliveryDate || '-');
    },
}

TPS.OSD.Form.Events = {
    addNewItemButtonSelector: '.tps-osd-addnew',
    saveDraftAndPrintButtonSelector: '#tps-osd-save-draft-print',
    saveDraftButtonSelector: '#tps-osd-save-draft',
    saveButtonSelector: '#tps-osd-save',
    editButtonSelector: '#tps-osd-edit',
    submitButtonSelector: '#tps-osd-submit',
    downloadButtonSelector: '#tps-osd-download',
    directShipmentWarningText: 'Please note that you have selected Direct Shipment. This means you are requesting the car to be sent directly to your location, and not Gothenburg.',
    init: function () {
        this.onAddNewItemClick();
        this.onSaveDraftAndPrintClick();
        this.onSaveDraftClick();
        this.onSaveClick();
        this.onEditClick();
        this.onSubmitClick();
        this.onDownloadClick();

        this.onRequiredFieldsFocus();
        this.onEmailFieldsFocus();

        this.onCountryChange();
        this.onYearChange();
        this.onModelChange();

        this.onVehicleChange();
        this.onExtColorChange();
        this.onIntColorChange();
        this.onPackageChange();
        this.onOptionChange();
        this.onAccessoryChange();
        this.onAdditionalInsuranceChange();
        this.onOfferChange();

        this.deliverLocationChange();
        this.deliveryAndDestinationChange();
        this.osdDepositChange();

        this.onDriverLicenseChange();
    },

    onAddNewItemClick: function () {
        $(document).on('click', this.addNewItemButtonSelector, function (e) {
            e.preventDefault();

            var self = TPS.OSD.Form.Events;
            var el = $(this);

            // Remove item
            if (!el.hasClass('active')) {
                var toRemoveItem = el.closest('.form-row');
                var toRemovePrice = toRemoveItem.next();

                toRemoveItem.remove();
                toRemovePrice.remove();

                TPS.OSD.Form.Calculator.calculateAllReplicableItems();
            // Add item
            } else {
                var toCloneItem = el.closest('.form-row');
                var toClonePrice = toCloneItem.next();

                var cloneItem = toCloneItem.clone();
                var clonePrice = toClonePrice.clone();

                toCloneItem.find(self.addNewItemButtonSelector).removeClass('active');

                cloneItem.find(TPS.OSD.Form.fieldsSelector).val('');
                // remove any ad-hoc fields
                cloneItem.find(TPS.OSD.Form.adHocFieldsSelector).remove();

                clonePrice.find('span').html('$0.00');

                clonePrice.insertAfter(toClonePrice);
                cloneItem.insertAfter(toClonePrice);
            }
        });
    },

    onSaveDraftAndPrintClick: function () {
        $(document).on('click', this.saveDraftAndPrintButtonSelector, function (e) {
            e.preventDefault();

            TPS.OSD.Form.Events.SaveDraft(true);
        });
    },

    onSaveDraftClick: function () {
        $(document).on('click', this.saveDraftButtonSelector, function (e) {
            e.preventDefault();

            TPS.OSD.Form.Events.SaveDraft(false);            
        });
    },

    SaveDraft: function (download) {
        TPS.OSD.PageLoader.show();

        CMSApp.OSD.API.Order.SaveDraft(TPS.OSD.Form.getFormData(), function (data) {
            if (data.Success && data.Success == true && data.InfoMessages && data.InfoMessages.length > 0) {

                var order = data.InfoMessages[0];

                alert('Draft saved!');                                        
                TPS.OSD.Nav.selectStep(1, order);

                if (download)
                    TPS.OSD.Form.Events.DownloadForm(order);

            } else if (data.ErrorMessages && data.ErrorMessages.length > 0) {
                alert(data.ErrorMessages[0]);
            } else {
                alert('Error saving draft. Please refresh the page and try again.');
            }

            TPS.OSD.PageLoader.hide();
        }, function () {
            alert('Error saving draft. Please refresh the page and try again.');
            TPS.OSD.PageLoader.hide();
        });
    },

    DownloadForm: function (orderID) {
        TPS.OSD.PageLoader.show();

        $.ajax({
            url: TPS.OSD.Form.WS.urlDownloadPdf.replace('{order}', orderID),
            type: 'GET',
            dataType: 'JSON',
        }).done(function (data) {
            if (data.Success && data.Success == true) {
                var url = data.InfoMessages[0];
                document.location.href = url;
            } else if (data.ErrorMessages && data.ErrorMessages.length > 0) {
                alert(data.ErrorMessages[0]);
            } else {
                alert('Error downloading order. Please refresh the page and try again.');
            }
        }).fail(function () {
            alert('Error downloading order. Please refresh the page and try again.');
        }).always(function () {
            TPS.OSD.PageLoader.hide();
        });
    },

    onSaveClick: function () {
        $(document).on('click', this.saveButtonSelector, function (e) {
            e.preventDefault();

            var isValid = TPS.OSD.Form.Validate.isValid();

            if (!isValid) {
                TPS.OSD.Form.Validate.showFormErrorMessage();
                return false;
            }

            TPS.OSD.PageLoader.show();

            CMSApp.OSD.API.Order.SaveOrder(TPS.OSD.Form.getFormData(), function (data) {
                if (data.Success && data.Success == true && data.InfoMessages && data.InfoMessages.length > 0) {
                    alert('Order saved!');

                    var order = data.InfoMessages[0];
                    TPS.OSD.Nav.selectStep(2, order);

                    TPS.OSD.Form.WS.loadWebServicesData();
                } else if (data.ErrorMessages && data.ErrorMessages.length > 0) {
                    alert(data.ErrorMessages[0]);
                } else {
                    alert('Error saving order. Please refresh the page and try again.');
                }

                TPS.OSD.PageLoader.hide();
            }, function () {
                alert('Error saving order. Please refresh the page and try again.');
                TPS.OSD.PageLoader.hide();
            });
        });
    },

    onEditClick: function () {
        $(document).on('click', this.editButtonSelector, function (e) {
            e.preventDefault();

            TPS.OSD.Nav.selectStep(1);

            TPS.OSD.Form.WS.loadWebServicesData();
        });
    },

    onSubmitClick: function () {
        $(document).on('click', this.submitButtonSelector, function (e) {
            e.preventDefault();

            if (!$(TPS.OSD.Form.disclaimerSelector).is(':checked')) {
                alert('Error submitting order. Please accept the disclaimer before submitting.');
                return false;
            }

            TPS.OSD.PageLoader.show();

            CMSApp.OSD.API.Order.SubmitOrder(TPS.OSD.Context.orderId, function (data) {
                if (data.Success && data.Success == true) {
                    alert('Order submitted!');

                    TPS.OSD.Nav.selectStep(3);

                    TPS.OSD.Form.WS.loadWebServicesData();
                } else if (data.ErrorMessages && data.ErrorMessages.length > 0) {
                    alert(data.ErrorMessages[0]);
                } else {
                    alert('Error submitting order. Please refresh the page and try again.');
                }

                TPS.OSD.PageLoader.hide();
            }, function () {
                alert('Error submitting order. Please refresh the page and try again.');
                TPS.OSD.PageLoader.hide();
            });
        });
    },

    onDownloadClick: function () {
        $(document).on('click', this.downloadButtonSelector, function (e) {
            e.preventDefault();

            TPS.OSD.Form.Events.DownloadForm(TPS.OSD.Context.orderId);
        });
    },
    
    onRequiredFieldsFocus: function () {
        $(document).on('focus', TPS.OSD.Form.fieldsSelector, function (e) {
            $(this).filter(TPS.OSD.Form.Validate.filterRequired).each(function () {
                TPS.OSD.Form.Validate.removeError(this);
            });
        });
    },

    onEmailFieldsFocus: function () {
        $(document).on('focus', TPS.OSD.Form.fieldsSelector, function (e) {
            $(this).filter(TPS.OSD.Form.Validate.filterEmail).each(function () {
                TPS.OSD.Form.Validate.removeError(this);
            });
        });
    },

    _helperOnFieldChangeType0: function (el, successCallback, completeCallback) {
        var val = el.val();

        if (val != '') {
            if (typeof successCallback == 'function') {
                successCallback.call(this, val);
            }
        }

        if (typeof completeCallback == 'function') {
            completeCallback.call(this);
        }
    },

    onCountryChange: function () {
        $(document).on('change', TPS.OSD.Form.countrySelector, function (e) {
            TPS.OSD.Form.Events._helperOnFieldChangeType0(
                $(this),
                TPS.OSD.Form.WS.loadStates,
                TPS.OSD.Form.Masks.setZipCodeMask
            );
        });
    },

    onYearChange: function () {
        $(document).on('change', TPS.OSD.Form.yearSelector, function (e) {
            TPS.OSD.Form.Events._helperOnFieldChangeType0(
                $(this),
                TPS.OSD.Form.WS.loadModels,

                function () {
                    TPS.OSD.Form.WS.setModels({});
                    $(TPS.OSD.Form.modelSelector).trigger('change');
                }
            );
        });
    },

    onModelChange: function () {
        $(document).on('change', TPS.OSD.Form.modelSelector, function (e) {
            TPS.OSD.Form.Events._helperOnFieldChangeType0(
                $(this),
                TPS.OSD.Form.WS.loadVehicles,

                function () {
                    TPS.OSD.Form.WS.setVehicles({});
                    $(TPS.OSD.Form.vehicleSelector).trigger('change');
                }
            );
        });
    },

    _helperOnFieldChangeType1: function (el, elPrice, elPriceDesc, successCallback, completeCallback, displayNegativePrice) {
        displayNegativePrice = displayNegativePrice == true ? true : false;

        var val = el.val();
        var price, formattedPrice;

        if (val != '') {
            price = el.find('option[value="' + val + '"]').data('price');
            formattedPrice = TPS.Util.formatPrice(displayNegativePrice ? -price : price);

            elPrice.data('price', price);
            elPrice.children('span').html(formattedPrice);

            if (elPriceDesc != null) {
                var description = decodeURIComponent(el.find('option[value="' + val + '"]').data('description'));
                elPriceDesc.val(description);
            }

            if (typeof successCallback == 'function') {
                successCallback.call(this, val);
            }

        } else {
            price = 0;
            formattedPrice = TPS.Util.formatPrice(displayNegativePrice ? -price : price);

            elPrice.data('price', price);
            elPrice.children('span').html(formattedPrice);

            if (elPriceDesc != null) {
                elPriceDesc.val('');
            }
        }

        if (typeof completeCallback == 'function') {
            completeCallback.call(this);
        }
    },

    onVehicleChange: function () {
        $(document).on('change', TPS.OSD.Form.vehicleSelector, function (e) {
            TPS.OSD.Form.Events._helperOnFieldChangeType1(
                $(this),
                $(TPS.OSD.Form.Calculator.basePriceSelector),
                null,

                function (vehicle) {
                    var exterionColor = $(TPS.OSD.Form.exteriorColorSelector).val();

                    if (exterionColor == "")
                        exterionColor = 0;

                    TPS.OSD.Form.WS.loadExtColors(vehicle);
                    TPS.OSD.Form.WS.loadIntColors(vehicle, exterionColor);
                    TPS.OSD.Form.WS.loadPackages(vehicle);
                    TPS.OSD.Form.WS.loadOptions(vehicle);
                    TPS.OSD.Form.WS.loadAccessories(vehicle);
                },

                function () {
                    TPS.OSD.Form.WS.setExteriorColors({});
                    $(TPS.OSD.Form.exteriorColorSelector).trigger('change');

                    TPS.OSD.Form.WS.setInteriorColors({});
                    $(TPS.OSD.Form.interiorColorSelector).trigger('change');

                    TPS.OSD.Form.WS.setPackages({});
                    $(TPS.OSD.Form.packageSelector).trigger('change');

                    TPS.OSD.Form.WS.setOptions({});
                    $(TPS.OSD.Form.optionSelector).trigger('change');

                    TPS.OSD.Form.WS.setAccessories({});
                    $(TPS.OSD.Form.accessorySelector).trigger('change');

                    TPS.OSD.Form.Calculator.calculateBasePrice();
                }
            );
        });

        $(document).on('change_load_edit_order', TPS.OSD.Form.vehicleSelector, function (e) {
            TPS.OSD.Form.Events._helperOnFieldChangeType1(
                $(this),
                $(TPS.OSD.Form.Calculator.basePriceSelector),
                null,
                null,
                TPS.OSD.Form.Calculator.calculateBasePrice
            );
        });
    },

    onExtColorChange: function () {
        $(document).on('change', TPS.OSD.Form.exteriorColorSelector, function (e, isInitialEditOrder) {
            TPS.OSD.Form.Events._helperOnFieldChangeType1(
                $(this),
                $(TPS.OSD.Form.Calculator.exteriorColorPriceSelector),
                $(TPS.OSD.Form.exteriorColorDescSelector),
                function (exteriorColor) {
                    var vehicle = $(TPS.OSD.Form.vehicleSelector).val();
                    if (!isInitialEditOrder && vehicle !== '') {
                        TPS.OSD.Form.WS.loadIntColors(vehicle, exteriorColor);
                    }
                },
                TPS.OSD.Form.Calculator.calculateBasePrice
            );
        });
    },

    onIntColorChange: function () {
        $(document).on('change', TPS.OSD.Form.interiorColorSelector, function (e) {
            TPS.OSD.Form.Events._helperOnFieldChangeType1(
                $(this),
                $(TPS.OSD.Form.Calculator.interiorColorPriceSelector),
                $(TPS.OSD.Form.interiorColorDescSelector),
                null,
                TPS.OSD.Form.Calculator.calculateBasePrice
            );
        });
    },

    onPackageChange: function () {
        $(document).on('change', TPS.OSD.Form.packageSelector, function (e) {
            TPS.OSD.Form.Events._helperOnFieldChangeType1(
                $(this),
                $(this).closest('.row').next('.row').find(TPS.OSD.Form.Calculator.packagePriceSelector),
                $(this).closest('.row').find(TPS.OSD.Form.packageDescSelector),
                null,
                TPS.OSD.Form.Calculator.calculatePackagesPrice
            );
        });
    },

    onOptionChange: function () {
        $(document).on('change', TPS.OSD.Form.optionSelector, function (e) {
            TPS.OSD.Form.Events._helperOnFieldChangeType1(
                $(this),
                $(this).closest('.row').next('.row').find(TPS.OSD.Form.Calculator.optionPriceSelector),
                $(this).closest('.row').find(TPS.OSD.Form.optionDescSelector),
                null,
                TPS.OSD.Form.Calculator.calculateOptionsPrice
            );
        });
    },

    onAccessoryChange: function () {
        $(document).on('change', TPS.OSD.Form.accessorySelector, function (e) {
            TPS.OSD.Form.Events._helperOnFieldChangeType1(
                $(this),
                $(this).closest('.row').next('.row').find(TPS.OSD.Form.Calculator.accessoryPriceSelector),
                $(this).closest('.row').find(TPS.OSD.Form.accessoryDescSelector),
                null,
                TPS.OSD.Form.Calculator.calculateAccessoriesPrice
            );
        });
    },

    onAdditionalInsuranceChange: function () {
        $(document).on('change', TPS.OSD.Form.additionalInsuranceSelector, function (e) {
            TPS.OSD.Form.Events._helperOnFieldChangeType1(
                $(this),
                $(TPS.OSD.Form.Calculator.additionalInsurancePriceSelector),
                $(TPS.OSD.Form.additionalInsuranceDescSelector),
                null,
                TPS.OSD.Form.Calculator.calculateAdditionalInsuranceAndOfferPrice
            );
        });
    },

    _helperOnFieldChangeType3: function (el, elPrice, elPriceDesc, successCallback, completeCallback, displayNegativePrice, newFieldIsRequired) {

        // apply the behaviour to price / description based on selection
        TPS.OSD.Form.Events._helperOnFieldChangeType1(el, elPrice, elPriceDesc, successCallback, completeCallback, displayNegativePrice = true);

        var fieldN, fieldV, newField, newFieldN, newFieldLabel, newFieldPlaceholder, newFieldAttr;

        fieldN = el.attr('name');
        fieldV = el.val();
        
        if (fieldN === 'offer') {
            newFieldN = 'offerAdditionalData';
            switch (fieldV) {
                case '1':
                    newFieldLabel = 'PIN Number';
                    newFieldPlaceholder = 'Enter a valid PIN';
                    newFieldAttr = { 'data-offer-number-type': 'PIN' };
                    break;
                case '2':
                    newFieldLabel = 'VIN Number';
                    newFieldPlaceholder = 'Enter a valid VIN number';
                    newFieldAttr = { 'data-offer-number-type' : 'VIN' };
                    break;
                default:
                    newFieldN = null;
                    newFieldAttr = null;
                    break;
            }
            // remove all associated fields if they exist
            elPriceDesc.parent('.editing-form-control-nested-control').nextAll(TPS.OSD.Form.adHocFieldsSelector).remove();
            // add new associated field based on offer selection
            if (newFieldN) {
                newField = TPS.OSD.Form._helperAddAssociatedField(newFieldN, newFieldLabel, newFieldPlaceholder, TPS.OSD.Form.adHocFieldsSelector.substring(1) + ' tps-osd-addnew-wrapper', newFieldIsRequired, 'text', newFieldAttr);
                elPriceDesc.parent('.editing-form-control-nested-control').after(newField);
            }

        }

    },

    onOfferChange: function () {
        $(document).on('change', TPS.OSD.Form.offerSelector, function (e) {

            TPS.OSD.Form.Events._helperOnFieldChangeType3(
                $(this),
                $(this).closest('.row').next('.row').find(TPS.OSD.Form.Calculator.offerPriceSelector),
                $(this).closest('.row').find(TPS.OSD.Form.offerDescSelector),
                null,
                TPS.OSD.Form.Calculator.calculateAdditionalInsuranceAndOfferPrice,
                true,
                true
            );
        });

        // validate VIN/PIN number fields
        $(document).on('blur', '.osd-ad-hoc-field input[type="text"]', function (e) {

            var el, elName, elVal, elLen, elParent, elNameSpace, elValidatingClasses, elErrorClasses, elSuccessClasses, elEmptyErrorClasses, submitBtn;

            el = $(this);
            elName = el.attr('data-offer-number-type');
            elVal = el.val().trim();
            elLen = elVal.length;
            elErrorClasses = '';
            elSuccessClasses = '';
            elEmptyErrorClasses = 'error error-required';

            elParent = el.closest('.form-control-wrapper');
            elNameSpace = elName == 'PIN' ? 'VerifyPIN' : elName == 'VIN' ? 'VerifyVIN' : null;

            submitBtn = $('#tps-osd-save');

            // if the field is enabled, not already validating and the field has a validation
            // method on the webservice we will call that function
            if (elNameSpace && !elParent.hasClass('validating') && !el.prop('disabled') && elLen > 0) {

                elErrorClasses = 'error error-offernumber';
                elSuccessClasses = 'success success-offernumber';
                elValidatingClasses = 'validating validating-offernumber';

                // reset field state (valid/invalid)
                elParent.addClass(elValidatingClasses).removeClass(elErrorClasses).removeClass(elSuccessClasses).removeClass(elEmptyErrorClasses);

                el.prop('disabled', true);
                submitBtn.prop('disabled', true);
                // call validation function
                CMSApp.OSD.API.Order[elNameSpace](elVal,
                    function (d) {
                        var parentClass = elErrorClasses;
                        var message = d.ErrorMessages;
                        var isValid = false;
                        if (d.Success) {
                            parentClass = elSuccessClasses;
                            message = '';
                            isValid = true;
                        }
                        el.data('isValid', isValid).prop('disabled', false);
                        submitBtn.prop('disabled', false);
                        elParent.children('.editing-form-control-nested-control').attr('data-validation-message', message);
                        elParent.removeClass(elValidatingClasses).addClass(parentClass);
                    },
                    function (d) {
                        elParent.removeClass(elValidatingClasses);
                        el.data('isValid', false).prop('disabled', false);
                        submitBtn.prop('disabled', false);
                    });

            }
            // if field is empty on blur,
            // show required message "please enter a value"
            else if (elLen == 0) {
                elParent.removeClass(elValidatingClasses).removeClass(elErrorClasses).removeClass(elSuccessClasses).addClass(elEmptyErrorClasses);
                el.data('isValid', false);
            }

        });

    },

    deliverLocationChange: function () {

        $(document).on('change', TPS.OSD.Form.deliveryLocationSelector, function (e) {

            var _targetVal = $(this).val();
            var _hiddenInput = $(TPS.OSD.Form.deliveryLocationSelector_hidden);

            _hiddenInput.val(_targetVal);

            // clear the delivery date value when a new
            // delivery location is selected
            // b/c we need to load the holidays
            // from the location selected
            $(TPS.OSD.Form.requestDeliveryDateSelector).val('');
            $(TPS.OSD.Form.requestDeliveryDateSelector).prop('disabled', true);
            TPS.OSD.Form.WS.loadHolidays(_targetVal);
            // if `Direct Shipment` is selected as the option:
            //if (_targetVal === '999') {
            //    alert(TPS.OSD.Form.Events.directShipmentWarningText);
            //} 



        });

        /*
        $(document).on('change', TPS.OSD.Form.deliveryLocation_DirectShipSelector, function (e) {

            // the locations selector
            var _locationsSelect = $(TPS.OSD.Form.deliveryLocationSelector);
            var _locationInput = $(TPS.OSD.Form.deliveryLocationSelector_hidden);
            var _currentLocationOption = _locationsSelect.val();

            if ($(e.target).prop('checked')) {
                _locationsSelect.val('999').prop('disabled', true);
                if (_currentLocationOption !== '999') {
                    _locationsSelect.trigger('change');
                }
            } else {
                _locationsSelect.val('1').prop('disabled', false).trigger('change');
            };
        });
        */

    },

    deliveryAndDestinationChange: function () {

        $(document).on('change', TPS.OSD.Form.Calculator.deliveryAndDestinationPriceSelector, function (e) {
            TPS.OSD.Form.Calculator.calculateFinalPrice();
        });
    },

    osdDepositChange: function () {
        $(document).on('change', TPS.OSD.Form.Calculator.osdDepositPriceSelector, function (e) {
            TPS.OSD.Form.Calculator.calculateFinalPrice();
        });
    },

    onDriverLicenseChange: function () {
        $(document).on('change', TPS.OSD.Form.driverLicenseSelector, function (e) {
            TPS.OSD.PageLoader.show();

            var input = e.target;
            var reader = new FileReader();

            reader.onload = function (event) {
                var data = event ? event.target.result : reader.content;
                $(TPS.OSD.Form.driverLicenseBinarySelector).val(data);
                TPS.OSD.PageLoader.hide();
            };

            reader.onerror = function (event) {
                console.error('File could not be read! Error code ' + event.target.error.code);
            };

            reader.readAsDataURL(input.files[0]);
        });
    },
}

TPS.OSD.Form.Calculator = {
    basePriceSelector: '#tps-osd-price-base',
    exteriorColorPriceSelector: '#tps-osd-price-ext-color',
    interiorColorPriceSelector: '#tps-osd-price-int-color',
    subTotalPriceSelector: '#tps-osd-price-sub-total',

    packagePriceSelector: '.tps-osd-price-package',
    packageSubTotalPriceSelector: '#tps-osd-price-packages-sub-total',

    optionPriceSelector: '.tps-osd-price-option',
    optionSubTotalPriceSelector: '#tps-osd-price-options-sub-total',

    accessoryPriceSelector: '.tps-osd-price-accessory',
    accessorySubTotalPriceSelector: '#tps-osd-price-accessories-sub-total',

    additionalInsurancePriceSelector: '#tps-osd-price-additional-insurance',
    offerPriceSelector: '.tps-osd-price-offer',
    additionalInsuranceAndOfferPriceSelector: '#tps-osd-price-additional-insurance-and-offer-sub-total',

    deliveryAndDestinationPriceSelector: '#deliveryAndDestination',
    osdDepositPriceSelector: '#osdDeposit',

    totalPriceSelector: '#tps-osd-price-grand-total',
    balanceDueSelector: '#tps-osd-price-balence-due',

    calculateAllReplicableItems: function () {
        var self = TPS.OSD.Form.Calculator;

        self.calculatePackagesPrice();
        self.calculateOptionsPrice();
        self.calculateAccessoriesPrice();
    },

    calculateBasePrice: function () {
        var self = TPS.OSD.Form.Calculator;
        var price = self.getBasePrice();
        var formattedPrice = TPS.Util.formatPrice(price);

        $(self.subTotalPriceSelector).html(formattedPrice);
        self.calculateFinalPrice();
    },

    getBasePrice: function () {
        var base = parseFloat($(this.basePriceSelector).data('price')) || 0;
        var extC = parseFloat($(this.exteriorColorPriceSelector).data('price')) || 0;
        var intC = parseFloat($(this.interiorColorPriceSelector).data('price')) || 0;
        var price = base + extC + intC;

        return price;
    },

    calculatePackagesPrice: function () {
        var self = TPS.OSD.Form.Calculator;
        var price = self.getPackagesPrice();
        var formattedPrice = TPS.Util.formatPrice(price);

        $(self.packageSubTotalPriceSelector).html(formattedPrice);
        self.calculateFinalPrice();
    },

    getPackagesPrice: function () {
        var packages = $(this.packagePriceSelector);
        var price = 0;

        packages.each(function () {
            price += parseFloat($(this).data('price')) || 0;
        });

        return price;
    },

    calculateOptionsPrice: function () {
        var self = TPS.OSD.Form.Calculator;
        var price = self.getOptionsPrice();
        var formattedPrice = TPS.Util.formatPrice(price);

        $(self.optionSubTotalPriceSelector).html(formattedPrice);
        self.calculateFinalPrice();
    },

    getOptionsPrice: function () {
        var options = $(this.optionPriceSelector);
        var price = 0;

        options.each(function () {
            price += parseFloat($(this).data('price')) || 0;
        });

        return price;
    },

    calculateAccessoriesPrice: function () {
        var self = TPS.OSD.Form.Calculator;
        var price = self.getAccessoriesPrice();
        var formattedPrice = TPS.Util.formatPrice(price);

        $(self.accessorySubTotalPriceSelector).html(formattedPrice);
        self.calculateFinalPrice();
    },

    getAccessoriesPrice: function () {
        var accessories = $(this.accessoryPriceSelector);
        var price = 0;

        accessories.each(function () {
            price += parseFloat($(this).data('price')) || 0;
        });

        return price;
    },

    calculateAdditionalInsuranceAndOfferPrice: function () {
        var self = TPS.OSD.Form.Calculator;
        var price = self.getAdditionalInsuranceAndOfferPrice();
        var formattedPrice = TPS.Util.formatPrice(price);

        $(self.additionalInsuranceAndOfferPriceSelector).html(formattedPrice);
        self.calculateFinalPrice();
    },

    getAdditionalInsuranceAndOfferPrice: function () {
        var ai = parseFloat($(this.additionalInsurancePriceSelector).data('price')) || 0;
        var offer = this.getOffersPrice();
        var price = ai - offer;

        return price;
    },

    getOffersPrice: function () {
        var offers = $(this.offerPriceSelector);
        var price = 0;

        offers.each(function () {
            price += parseFloat($(this).data('price')) || 0;
        });

        return price;
    },

    calculateFinalPrice: function () {
        var self = TPS.OSD.Form.Calculator;
        var price = self.getFinalPrice();
        var formattedPrice = TPS.Util.formatPrice(price);

        $(self.totalPriceSelector).html(formattedPrice);
        $(self.totalPriceSelector).data('price', price);

        self.calculateBalanceDue();
    },

    getFinalPrice: function () {
        var self = TPS.OSD.Form.Calculator;

        var dad = parseFloat($(self.deliveryAndDestinationPriceSelector).data('price')) || 0;
        var total = self.getBasePrice() + self.getPackagesPrice() + self.getOptionsPrice() + self.getAccessoriesPrice() + self.getAdditionalInsuranceAndOfferPrice();
        var price = dad + total;

        return price;
    },

    calculateBalanceDue: function () {
        var self = TPS.OSD.Form.Calculator;
        var price = self.getBalanceDue();
        var formattedPrice = TPS.Util.formatPrice(price);

        $(self.balanceDueSelector).html(formattedPrice);
        $(self.balanceDueSelector).data('price', price);
    },

    getBalanceDue: function () {
        var self = TPS.OSD.Form.Calculator;

        var base = parseFloat($(self.totalPriceSelector).data('price')) || 0;
        var osdd = parseFloat($(self.osdDepositPriceSelector).data('price')) || 0;
        var price = base - osdd;

        return price;
    },
}

TPS.OSD.Form.Masks = {
    countrySelector: '#country',
    codeSelector: '#code',
    phoneSelector: '#homePhoneNumber, #mobilePhoneNumber',
    emailSelector: '#email, #alternateEmail',
    fancyInputFilesSelector: '.tps-fancy-input-file',

    init: function () {
        // this.setZipCodeMask(); // Only called on country change event AND on order load
        this.setPhoneMask();
        this.setEmailMask();
        this.setFancyInputFiles();
    },

    setZipCodeMask: function () {
        var self = TPS.OSD.Form.Masks;
        var country = $(self.countrySelector + ' :selected').text();

        if (country == 'Canada') {
            $(self.codeSelector).unmask().mask('A0A 0A0', {
                translation: {
                    'A': { pattern: /[A-Za-z]/ }
                }
            });
        } else {
            $(self.codeSelector).unmask().mask('00000');
        }
    },

    setPhoneMask: function () {
        var self = TPS.OSD.Form.Masks;
        $(self.phoneSelector).unmask().mask('(000) 000-0000');
    },

    setEmailMask: function () {
        var self = TPS.OSD.Form.Masks;

        $(self.emailSelector).unmask().mask('A', {
            translation: {
                'A': { pattern: /[\w@\-.+]/, recursive: true }
            }
        });
    },

    setFancyInputFiles: function () {
        var self = TPS.OSD.Form.Masks;
        $(self.fancyInputFilesSelector).tpsFancyFileInput();
    },
}

TPS.OSD.Form.Validate = {
    formErrorMessageSelector: '#formError',

    init: function () {
        this.addFormErrorMessage();
    },

    addFormErrorMessage: function () {
        $(TPS.OSD.Form.formWrapperSelector).find('.tps-osd-form-form-section:last-child .columns').append('<p class="ErrorLabel" id="formError" style="display: none">The entered values cannot be saved. Please see the fields above for details.</p>');
    },

    hideFormErrorMessage: function (el) {
        $(TPS.OSD.Form.Validate.formErrorMessageSelector).hide();
    },

    showFormErrorMessage: function (el) {
        $(TPS.OSD.Form.Validate.formErrorMessageSelector).show();
    },

    removeError: function (el) {
        TPS.OSD.Form.Validate.hideFormErrorMessage();
        $(el).closest('.form-control-wrapper').removeClass('error').removeClass('error-email').removeClass('error-offernumber').removeClass('error-required');
    },

    filterRequired: function (index) {
        if ($(this).attr('name')) {
            var isRequired = $(this).closest('.form-control-wrapper').hasClass('required');
            var isNotDescription = ($(this).attr('name')).indexOf('Description') == -1; // Support field
            var isNotBinary = ($(this).attr('name')).indexOf('Binary') == -1; // Driver's License field
            var isNotFile = ($(this).attr('name')).indexOf('File') == -1; // Driver's License field
            var isNotHidden = $(this).attr('type') != 'hidden'; // Driver's License field
        }

        return isRequired && isNotDescription && isNotBinary && isNotFile && isNotHidden;
    },

    filterEmail: function (index) {
        var hasNoPrevError = !$(this).closest('.form-control-wrapper').hasClass('error');
        var isEmail = $(this).attr('type') == 'email';
        return hasNoPrevError && isEmail;
    },
    isValid: function () {
        var valid = true;

        $(TPS.OSD.Form.fieldsSelector).each(function () {
            TPS.OSD.Form.Validate.removeError(this);
        });

        $(TPS.OSD.Form.fieldsSelector).filter(TPS.OSD.Form.Validate.filterRequired).each(function () {
            var val = $.trim($(this).val());

            if (val == '') {
                valid = false;
                $(this).closest('.form-control-wrapper').addClass('error').addClass('error-required');
            }
        });

        $(TPS.OSD.Form.fieldsSelector).filter(TPS.OSD.Form.Validate.filterEmail).each(function () {
            var val = $.trim($(this).val());

            if (val != '' && !TPS.Util.validateEmail(val)) {
                valid = false;
                $(this).closest('.form-control-wrapper').addClass('error').addClass('error-email');
            }
        });

        // check if PIN/VIN numbers are valid
        $(TPS.OSD.Form.fieldsSelector).filter(TPS.OSD.Form.offerNumSelector).each(function () {
            var val = $.trim($(this).val());
            if (val != '' && $(this).data('isValid') != true) {
                valid = false;
                $(this).closest('.form-control-wrapper').addClass('error').addClass('error-offernumber');
            }
        });

        return valid;
    },
}

// Order History page

TPS.OSD.History = {
    downloadButtonSelector: '.tps-order-table-download',
    deleteOrderSelector: '.tps-order-table-delete',
    transferButtonSelector: '.tps-order-table-transfer',

    transferModalSelector: '#osdTransferModal',
    transferModalSectionSelector: '.tps-osd-modal-section',
    transferModalDetailsSectionSelector: '#osdTransferModalDetails',
    transferModalConfirmSectionSelector: '#osdTransferModalConfirm',
    transferModalResultSectionSelector: '#osdTransferModalResult',
    transferModalButtonBackSelector: '#osdTransferBtnBack',
    transferModalButtonConfirmSelector: '#osdTransferBtnConfirm',
    transferModalListSelector: '.tps-osd-modal-transfer-list',
    transferModalListLinkSelector: '.tps-osd-modal-transfer-list-link',

    filterDealerSelector: '#dplDealer',
    filterStatusSelector: '#dplStatus',
    inputCurrentRetailerSelector: '#currentRetailerID',
    inputSelectedOrderSelector: '#selectedOrderID',
    inputSelectedRetailerSelector: '#selectedRetailerID',

    init: function () {
        TPS.OSD.PageLoader.init();
        TPS.OSD.Form.WS.loadWebServices();

        this.onDownloadClick();
        this.onDeleteOrderClick();
        this.onTransferClick();
        this.onFilterDealerChange();
        this.onFilterStatusChange();
        this.maybePreselectDealerDropdown();
        this.maybePreselectStatusDropdown();
        this.populateTransferModalList();
        this.onTransferListLinkClick();
        this.onTransferButtonBackClick();
        this.onTransferButtonConfirmClick();
    },

    onDownloadClick: function () {
        $(document).on('click', this.downloadButtonSelector, function (e) {
            e.preventDefault();

            TPS.OSD.PageLoader.show();

            var order = $(this).data('order');

            $.ajax({
                url: TPS.OSD.Form.WS.urlDownloadPdf.replace('{order}', order),
                type: 'GET',
                dataType: 'JSON',
            }).done(function (data) {
                if (data.Success && data.Success == true) {
                    var url = data.InfoMessages[0];
                    document.location.href = url;
                } else if (data.ErrorMessages && data.ErrorMessages.length > 0) {
                    alert(data.ErrorMessages[0]);
                } else {
                    alert('Error downloading order. Please refresh the page and try again.');
                }
            }).fail(function () {
                alert('Error downloading order. Please refresh the page and try again.');
            }).always(function () {
                TPS.OSD.PageLoader.hide();
            });
        });
    },

    onDeleteOrderClick: function () {
        function deleteOrder(order) {
            TPS.OSD.PageLoader.show();
            CMSApp.OSD.API.Order.DeleteOrder(order, function (data) {
                if (data.Success && data.Success == true) {
                    alert('Draft delete!');
                    location.reload();
                } else if (data.ErrorMessages && data.ErrorMessages.length > 0) {
                    alert(data.ErrorMessages[0]);
                } else {
                    alert('Error delete draft. Please refresh the page and try again.');
                }

                TPS.OSD.PageLoader.hide();
            }, function () {
                alert('Error delete draft. Please refresh the page and try again.');
                TPS.OSD.PageLoader.hide();
            });
        }

        $(document).on('click', this.deleteOrderSelector, function (e) {
            e.preventDefault();
            var retVal = confirm("Delete this order?");
            var order = $(this).data('order');

            if (retVal == true) {
                deleteOrder(order);
                return true;
            } else {
                return false;
            }
        });
    },

    onTransferClick: function () {
        var self = this;

        $(document).on('click', self.transferButtonSelector, function (e) {
            e.preventDefault();

            var orderID = this.dataset.order;

            $(self.inputSelectedOrderSelector).val(orderID);
            self.populateTransferModalOrderDetails(this.dataset);

            $(self.transferModalSelector).foundation('open');
        });
    },

    onTransferListLinkClick: function () {
        var self = this;

        $(document).on('click', self.transferModalListLinkSelector, function (e) {
            e.preventDefault();
            var retailerID = this.dataset.retailerid;
            var retailerName = this.dataset.retailername;

            $(self.inputSelectedRetailerSelector).val(retailerID);

            $(self.transferModalSectionSelector).removeClass('active');
            $(self.transferModalConfirmSectionSelector).addClass('active');

            $('#osdTranferModalConfirmName').html(retailerName);
        });
    },

    onTransferButtonBackClick: function () {
        var self = this;

        $(document).on('click', self.transferModalButtonBackSelector, function (e) {
            e.preventDefault();

            $(self.transferModalSectionSelector).removeClass('active');
            $(self.transferModalDetailsSectionSelector).addClass('active');
        });
    },

    onTransferButtonConfirmClick: function () {
        var self = this;

        $(document).on('click', self.transferModalButtonConfirmSelector, function (e) {
            e.preventDefault();

            var button = $(this);
            var selectedOrderID = $(self.inputSelectedOrderSelector).val();
            var selectedRetailerID = $(self.inputSelectedRetailerSelector).val();

            if (selectedOrderID !== "" && selectedRetailerID !== "" && !button.hasClass('submitting')) {
                button.addClass('submitting').append(TPS.Util.submitSpinner);

                CMSApp.OSD.API.Order.TransferOrder(
                    selectedOrderID,
                    selectedRetailerID,
                    function (d) {
                        if (d.Success && d.Success == true) {
                            location.reload();
                        } else {
                            $(self.transferModalSectionSelector).removeClass('active');
                            $(self.transferModalResultSectionSelector).addClass('active');

                            var message = 'Error while transferring order. ';

                            if (d.Messages && d.Messages.length > 0) {
                                message += d.Messages[0];
                            }

                            $('#osdTransferModalResultText').html(message);

                        }

                        button.find('.icon').remove();
                        button.removeClass('submitting');
                    },
                    function (d) {
                        TPS.Util.displayError(d);

                        $(self.transferModalSectionSelector).removeClass('active');
                        $(self.transferModalResultSectionSelector).addClass('active');

                        $('#osdTransferModalResultText').html('Error transferring order. Please refresh the page and try again.');

                        button.find('.icon').remove();
                        button.removeClass('submitting');
                    }
                );
            }
        });
    },

    onFilterDealerChange: function () {
        $(this.filterDealerSelector).on('change', function (e) {
            var dealerDropdown = this;

            var qs = new URLSearchParams(document.location.search.slice(1));
            qs.set('RetailerID', dealerDropdown.value);

            var url = document.location.pathname + '?' + qs.toString();

            dealerDropdown.setAttribute('disabled', 'disabled');

            document.location.href = url;
        });
    },

    onFilterStatusChange: function () {
        $(this.filterStatusSelector).on('change', function (e) {
            var statusDropdown = this;

            var qs = new URLSearchParams(document.location.search.slice(1));
            qs.set('Status', statusDropdown.value);

            var url = document.location.pathname + '?' + qs.toString();

            statusDropdown.setAttribute('disabled', 'disabled');

            document.location.href = url;
        });
    },

    maybePreselectDealerDropdown: function () {
        var retailerID = TPS.Util.getUrlParameter('RetailerID');
        if (retailerID != null) {
            $(this.filterDealerSelector).val(retailerID);
        }
    },

    maybePreselectStatusDropdown: function () {
        var status = TPS.Util.getUrlParameter('Status');
        if (status != null) {
            $(this.filterStatusSelector).val(status.replace(/\+/g, " "));
        }
    },

    populateTransferModalOrderDetails: function (dataset) {
        $('#osdTranferModalTOAOrderNumber').html(dataset.ordercode);
        $('#osdTranferModalVistaOrderNumber').html(dataset.vista);
        $('#osdTranferModalOrderDate').html(dataset.orderdate);
        $('#osdTranferModalRequestDeliveryDate').html(dataset.deliverydate);
        $('#osdTranferModalBuyerName').html(dataset.buyer);
        if (dataset.status) {
            $('#osdTranferModalStatus').html(dataset.status.charAt(0).toUpperCase() + dataset.status.substr(1).toLowerCase());
        }
        $('#osdTranferModalOrderOwnedBy').html(dataset.owner);
    },
    populateTransferModalList: function () {
        var self = this;
        var currentCustomerID = $(self.inputCurrentRetailerSelector).val();
        var transferModalList = $(self.transferModalListSelector);

        CMSApp.OSD.API.Order.GetCompanyRetailers(
            currentCustomerID,
            function (d) {
                if (d.Success && d.Success == true && d.ObjectVM) {
                    var html = '';

                    for (var i = 0; i < d.ObjectVM.length; i++) {
                        html += '<li><span>' + d.ObjectVM[i].FullName + '</span><a href="#" class="tps-osd-modal-transfer-list-link" data-retailername="' + d.ObjectVM[i].FullName + '" data-retailerid="' + d.ObjectVM[i].RetailerID + '">Select</a></li>';
                    }

                    transferModalList.html(html);

                } else if (d.Messages && d.Messages.length > 0) {
                    alert(d.Messages[0]);
                } else {
                    alert('Error loading order. Please refresh the page and try again.');
                }
            },
            function (d) {
                TPS.Util.displayError(d);
                alert('Error loading order. Please refresh the page and try again.');
            }
        );
    }
}

// Order Download page

TPS.OSD.Download = {
    init: function () {
        TPS.OSD.Context.init();
        TPS.OSD.PageLoader.init();
        TPS.OSD.Nav.init();
        TPS.OSD.Form.WS.init();
    },
}
